import { Linkedin, Facebook, Youtube, Twitter, Instagram } from 'lucide-react';
import { teamSocialHref } from '../../utils/socialProfileUrl';

const LINK_DEFS = [
  { key: 'linkedin', field: 'linkedin', Icon: Linkedin },
  { key: 'facebook', field: 'facebook', Icon: Facebook },
  { key: 'youtube', field: 'youtube', Icon: Youtube },
  { key: 'twitter', field: 'twitter', Icon: Twitter },
  { key: 'instagram', field: 'instagram', Icon: Instagram }
];

export default function TeamSocialLinks({ member, className = 'team-member-socials' }) {
  if (!member) return null;
  const links = LINK_DEFS.map(({ key, field, Icon }) => {
    const href = teamSocialHref(key, member[field]);
    return href ? { key, href, Icon } : null;
  }).filter(Boolean);
  if (links.length === 0) return null;
  return (
    <div className={className}>
      {links.map(({ key, href, Icon }) => (
        <a key={key} href={href} target="_blank" rel="noopener noreferrer" aria-label={key}>
          <Icon size={18} />
        </a>
      ))}
    </div>
  );
}
